<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label }}
  </mat-label>
  <input
    matInput
    [placeholder]="placeholder"
    readonly
    [errorStateMatcher]="this"
    [formControl]="textControl"
    [disabled]="isDisabled"
    [required]="isRequiredControl"
    spellcheck="false"
    autocomplete="off"
  />
  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (!isDisabled) {
    <i matSuffix [nimbusIcon]="icons.UPLOAD" (click)="openFileDialog()"></i>
  }
  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
  @if (previewNotSupported$ | async) {
    <mat-hint align="start">
      <i [nimbusIcon]="icons.INFO_CIRCLE" class="error-triangle"></i
      >{{ TranslationKeys.ManageWorkflowPlaylistWmaPreviewNotSupported | translate }}
    </mat-hint>
  }
</mat-form-field>
@if (!(previewNotSupported$ | async) && !isFileInvalid) {
  <nimbus-input-media-player
    [mode]="mediaPlayerMode"
    [source]="value"
    [invalidateCache]="true"
    [withBorder]="false"
  ></nimbus-input-media-player>
}
